<template>
  <div class="course-weekdays inline-replacement">
    <weui-group type="checkbox" :title="`您已设置${formatDate(draft.date)}为上课日期，如需设置重复课程，请务必涵盖${formatWeekday(draft.date)}`">
      <weui-checkbox v-for="(_, index) in weekdays" v-model="weekdays[index]" :key="index">
        <p :class="{ 'text-primary': (day === index || draft.weekdays.indexOf(index) >= 0) }">{{ getWeekdayText(index) }}</p>
      </weui-checkbox>
    </weui-group>

    <weui-button-area>
      <weui-button type="primary" @click="saveWeekdays">设置</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiCheckbox, WeuiButtonArea, WeuiButton } from '@/components/weui';
import mixinFormatters from '@/mixins/formatters';
import { WEEKDAYS } from '@/utils/formatter';
import datetimeUtils from '@/utils/datetime';

import { COURSE_DRAFT_FILL } from '@/store/course/types';

const { mapState, mapMutations } = createNamespacedHelpers('course');

export default {
    data() {
        return {
            weekdays: Array(7).fill(false),
            day: null,
        };
    },
    computed: {
        ...mapState({
            draft: state => state.draft,
        }),
    },
    mounted() {
        this.draft.weekdays.forEach((wd) => {
            Vue.set(this.weekdays, wd, true);
        });
        this.day = datetimeUtils.getWeekday(this.draft.date);
    },
    methods: {
        ...mapMutations({
            fillDraft: COURSE_DRAFT_FILL,
        }),
        getWeekdayText(weekday) {
            return `每${WEEKDAYS[weekday]}`;
        },
        saveWeekdays() {
            if (!this.weekdays[this.day]) {
                // TODO: 必须选择当前日期对应的周x
            }

            const weekdays = [];
            this.weekdays.forEach((wd, index) => {
                if (wd) {
                    weekdays.push(index);
                }
            });

            this.fillDraft({
                weekdays,
            });
            this.$router.go(-1);
        },
    },
    mixins: [
        mixinFormatters,
    ],
    components: {
        WeuiGroup,
        WeuiCheckbox,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Weekdays.vue